import { render, staticRenderFns } from "./iconTruck.vue?vue&type=template&id=5d64152e&scoped=true&"
import script from "./iconTruck.vue?vue&type=script&lang=js&"
export * from "./iconTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d64152e",
  null
  
)

export default component.exports